import React from "react"
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Pagination,
  Spinner,
  Chip,
} from "@heroui/react"
import { useNavigate } from "react-router-dom"

interface Props {
  teachers: TeachersSearchResult
  pages: number
  page: number
  loading: boolean
  onPageChange(page: number): void
}

const TeachersTable = (props: Props) => {
  const { teachers, loading, pages, page, onPageChange } = props

  const navigate = useNavigate()

  const getValue = (value: any) => {
    if (loading) {
      return <Spinner size="sm" />
    }
    return value
  }

  return (
    <Table
      isCompact
      bottomContent={
        pages > 0 ? (
          <div className="flex w-full justify-center">
            <Pagination
              isCompact
              showControls
              showShadow
              color="primary"
              page={page}
              total={pages}
              onChange={(page) => onPageChange(page)}
            />
          </div>
        ) : null
      }
    >
      <TableHeader>
        <TableColumn>מנוי</TableColumn>
        <TableColumn>שם פרטי</TableColumn>
        <TableColumn>שם משפחה</TableColumn>
        <TableColumn>מספר נייד</TableColumn>
        <TableColumn>תאריך חידוש מנוי</TableColumn>
        <TableColumn>תלמידים פעילים</TableColumn>
      </TableHeader>
      <TableBody emptyContent={"No rows to display."}>
        {teachers.map((teacher, index) => {
          const isActive = ["MONTHLY","GIFT"].includes(teacher.plan)
          return (
            <TableRow
              key={`${index}`}
              onClick={() => navigate(`/teachers/${teacher.uid}`)}
            >
              <TableCell>
                <Chip
                  color={isActive ? "success" : "danger"}
                  variant="flat"
                >
                  {isActive ? "פעיל" : "לא פעיל"}
                </Chip>
              </TableCell>
              <TableCell>{getValue(teacher.firstName)}</TableCell>
              <TableCell>{getValue(teacher.lastName)}</TableCell>
              <TableCell>{getValue(teacher.phoneNumber)}</TableCell>
              <TableCell>
                {getValue(
                  teacher?.renewalDate
                    ? new Date(teacher?.renewalDate)?.toLocaleDateString?.(
                        "he-IL"
                      ) ?? "-"
                    : "-"
                )}
              </TableCell>
              <TableCell>{getValue(teacher?.activeStudentsCount)}</TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
export default TeachersTable
